<ion-header
  class="ion-padding ion-no-border"
  [ngStyle]="{ display: TOHIDE ? 'none' : 'block' }"
  [ngClass]="{ 'ion-margin-bottom': !SEARCHBARPRESENT }"
>
  <ion-toolbar>
    @if (shouldShowBackButton) {
      <ion-buttons slot="start">
        <ion-back-button text="" icon="arrow-back" defaultHref="/home" color="white"></ion-back-button>
      </ion-buttons>
    }

    @if (SEARCHBARPRESENT) {
      <ion-searchbar
        [disabled]="isBlockedApp || !internetAvailable"
        color="garnet-dark"
        [(ngModel)]="SEARCHBARVALUE"
        [placeholder]="'COMMON.SEARCH' | translate"
        (ngModelChange)="emitNewValue()"
      ></ion-searchbar>
    } @else {
      @if (TITLE) {
        <ion-label class="ion-text-wrap ion-text-bold ion-text-uppercase" color="white"> {{ TITLE }} </ion-label>
      }
    }
  </ion-toolbar>
</ion-header>
